import { vnTemplate } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";


declare let ko: any;
declare let AmCharts: any;

export class amCharts_v4_area_line_chart extends vnTemplate{

    protected buildViewModel(): any {
        let _this = this;
        return  {
            idChart: ko.observable("chartDiv_" + _this.idElement),
            category: ko.observable(""),
            cssWidth: ko.observable("100%"),
            cssHeight: ko.observable("300px"),
            xAxisRotation: ko.observable(0),
            xAxisFontSize: ko.observable(8),
            seriesTooltipFormat: ko.observable("{name}: [bold]{valueY}[/]"),
            show: ko.observable(true),
            yaxis: ko.observableArray([]),
            ranges: ko.observableArray([]),
        };
    }

    protected getMainElementClasses(): Array<string>{
        return ["graph"];
    }

    protected getTemplateHtml(): string {
        return `<div data-bind="attr: {id: idChart}, style: {width: cssWidth, height: cssHeight, display: (show() == true) ? 'block': 'none' }"></div>`;
    }

    protected getTemplateName(): string {
        return "amCharts_v4_area_line_chart";
    }

    public setXAxisRotation(rotation: number): void {
        this.getTemplateViewModel().xAxisRotation(rotation);
    }


    public setXAxisFontSize(rotation: number): void {
        this.getTemplateViewModel().xAxisFontSize(rotation);
    }

    public setSeriesTooltipFormat(tooltipFormat: string): void {
        this.getTemplateViewModel().seriesTooltipFormat(tooltipFormat);
    }

    public setCategory(category) {
        this.getTemplateViewModel().category(category);
    }

    public setYaxis(axis) {
        this.getTemplateViewModel().yaxis(axis);
    }

    public setRanges(ranges) {
        this.getTemplateViewModel().ranges(ranges);
    }

    public show(): void {
        this.getTemplateViewModel().show(true);
    }

    public hide(): void {
        this.getTemplateViewModel().show(false);
    }

    public drawChart(chartData) {

        let _this = this;
        am4core.useTheme(am4themes_animated);
        let numberFormatter = new am4core.NumberFormatter();
        let chart = am4core.create("chartDiv_" + _this.idElement, am4charts.XYChart);

        chart.data = chartData.data;
        numberFormatter.numberFormat = "#,###";

        chart.dateFormatter.inputDateFormat = "yyyy-MM-dd";
        chart.data.forEach(function (dataItem) {
            dataItem.date = new Date(dataItem.date);
        });

        // Create category axis
        let categoryAxis = chart.xAxes.push(new am4charts.DateAxis());
        categoryAxis.dataFields.date = "date";
        categoryAxis.renderer.minGridDistance = 60;
        categoryAxis.renderer.verticalCenter = "top"
        categoryAxis.numberFormatter = numberFormatter;
        categoryAxis.renderer.labels.template.disabled = false;
        categoryAxis.renderer.grid.template.disabled = false;

        // Create value axis
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.renderer.labels.template.disabled = false;
        valueAxis.renderer.grid.template.disabled = false;
        if (chartData.hasOwnProperty('minimalValue')) {
            valueAxis.min = chartData.minimalValue;
        }

        // Create line series 1
        let series1 = chart.series.push(new am4charts.LineSeries());
        series1.dataFields.valueY = chartData.series1ValueY;
        series1.dataFields.dateX = chartData.series1DateX;
        series1.name = chartData.series1Name;
        series1.strokeWidth = 2;
        series1.fillOpacity = 0.5;
        series1.fill = am4core.color(chartData.series1Fill);

        // Create line series 2
        let series2 = chart.series.push(new am4charts.LineSeries());
        series2.dataFields.valueY = chartData.series2ValueY;
        series2.dataFields.dateX = chartData.series2DateX;
        series2.name = chartData.series2Name;
        series2.strokeWidth = 2;
        series2.fillOpacity = 0.5;
        series2.fill = am4core.color(chartData.series2Fill);


        // Enable stacking
        chart.seriesContainer.layout = "absolute";
        series1.stacked = true;
        series2.stacked = true;

        series2.tooltipText = "Baseline S/A: {baseline}\nActive S/A: {valueY}\nTotal S/A: {tooltipTotal}";

        chart.data.forEach(function(dataItem) {
            let baseline = parseFloat(dataItem.baseline);
            let activeSA = parseFloat(dataItem.activeSA);
            dataItem.tooltipTotal = baseline + activeSA;
        });

        // Enable legend
        if(chartData.legend){

            chart.legend = new am4charts.Legend();
        }

        // Enable tooltips
        chart.cursor = new am4charts.XYCursor();

        chart.logo.disabled = true;

    }
}


// WEBPACK FOOTER //
// ./js/components/templates/amCharts_v4_area_line_chart.ts